var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { ClientOnlyContent } from '../../components/atoms/ClientOnlyContent';
import { MainLayout } from '../../components/layouts/MainLayout';
import { initialDataSlice } from '../../store/initialData/initialData.slice';
import { connect } from 'react-redux';
import { GAService } from '../../services/GAService';
import { useGAEventMeta } from '../../hooks/useGAEventMeta.hook';
import { useAudienceMarker } from '../../hooks/useAudienceMarker.hook';
import { Container } from '../../uikit/grid';
var mapStateToProps = function (state) { return ({
    placementId: initialDataSlice.selectors.getPlacementId(state),
    loanAmount: initialDataSlice.selectors.getAmount(state),
}); };
export var ImmoweltPageRaw = function (_a) {
    var placementId = _a.placementId, loanAmount = _a.loanAmount;
    var gaEventMeta = useGAEventMeta();
    var audienceMarker = useAudienceMarker();
    var iframeUrl = useMemo(function () {
        var base = 'https://www.immowelt.de/immobilienfinanzierung-anfragen/';
        var queryParams = new URLSearchParams(__assign(__assign({ cid: 'SMAVA' }, (audienceMarker !== null && { pid: audienceMarker })), (typeof loanAmount !== 'undefined' && { price: String(loanAmount) })));
        return "".concat(base, "?").concat(queryParams.toString());
    }, [audienceMarker, loanAmount]);
    var frameRef = useRef(null);
    var handlePostmessage = useCallback(function (_a) {
        var origin = _a.origin, data = _a.data;
        if (origin !== 'https://www.immowelt.de') {
            return;
        }
        if (data === 'Success') {
            GAService.onLeadCreated(placementId, gaEventMeta);
        }
        if (typeof data.height === 'number' && frameRef.current !== null) {
            frameRef.current.style.height = "".concat(data.height, "px");
        }
    }, [gaEventMeta]);
    useEffect(function () {
        window.addEventListener('message', handlePostmessage);
        return function onUnmount() {
            window.removeEventListener('message', handlePostmessage);
        };
    }, []);
    return (React.createElement(MainLayout, null,
        React.createElement(Container, { disableGutters: function (theme) { return theme.breakpoints.down('lg'); } },
            React.createElement(ClientOnlyContent, null,
                React.createElement("iframe", { src: iframeUrl, ref: frameRef, frameBorder: "0", scrolling: "no", style: { width: '100%' } })))));
};
export var ImmoweltPage = connect(mapStateToProps)(ImmoweltPageRaw);
